import { render, staticRenderFns } from "./indexnewlist.vue?vue&type=template&id=3e2d0d8e&"
import script from "./indexnewlist.vue?vue&type=script&lang=js&"
export * from "./indexnewlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports